<template>
	<div style="display: flex;justify-content: space-between;flex-wrap: wrap;padding: 20px;">
		<div style="display: flex;flex-direction: column;color:#fff;font-size: 14px;width: 31.5%;margin-bottom: 30px;">
			<div style="flex:1;background-color: rgb(75, 83, 87);display: flex;flex-direction: column;">
				<div style="padding: 15px;border-bottom: 1px solid #3f4649;display: flex;align-items: center;">
					<span>联系方式</span>
					<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(0)">
				</div>
				<div style="padding: 40px 20px;display: flex;align-items: center;" class="form">
					<el-input size="small" v-model="setting_data.connect" placeholder="请输入联系方式"
						style="width: flex:1;"></el-input>
					<el-button size="small" type="primary" style="margin-left: 10px;" round
						@click="toEdit('connect','请输入联系方式')">确认修改</el-button>
				</div>
			</div>
		</div>
		<div style="display: flex;flex-direction: column;color:#fff;font-size: 14px;width: 31.5%;margin-bottom: 30px;">
			
			<div style="flex:1;background-color: rgb(75, 83, 87);display: flex;flex-direction: column;">
				<div style="padding: 15px;border-bottom: 1px solid #3f4649;display: flex;align-items: center;">
					<span>开发者公告</span>
					<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(1)">
				</div>
				<div style="padding: 40px 20px;display: flex;align-items: center;" class="form">
					<el-input size="small" v-model="setting_data.inform" placeholder="请输入开发者公告"
						style="width: flex:1;"></el-input>
					<el-button size="small" type="primary" style="margin-left: 10px;" round
						@click="toEdit('inform','请输入开发者公告')">确认修改</el-button>
				</div>
			</div>
		</div>
		<div style="display: flex;flex-direction: column;color:#fff;font-size: 14px;width: 31.5%;margin-bottom: 30px;">
			<div style="flex:1;background-color: rgb(75, 83, 87);display: flex;flex-direction: column;">
				<div style="padding: 15px;border-bottom: 1px solid #3f4649;display: flex;align-items: center;">
					<span>接口安全密码</span>
					<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(2)">
				</div>
				
				<div style="padding: 40px 20px;display: flex;align-items: center;" class="form">
					<el-input size="small" v-model="setting_data.apipassword" placeholder="请输入接口安全密码"
						style="width: flex:1;"></el-input>
					<el-button size="small" type="primary" style="margin-left: 10px;" round
						@click="toEdit('apipassword','请输入接口安全密码')">确认修改</el-button>
				</div>
			</div>
		</div>
		<div style="display: flex;flex-direction: column;color:#fff;font-size: 14px;width: 31.5%;margin-bottom: 30px;">
			<div style="flex:1;background-color: rgb(75, 83, 87);display: flex;flex-direction: column;">
				<div style="padding: 15px;border-bottom: 1px solid #3f4649;display: flex;align-items: center;">
					<span>是否开启api安全模式</span>
					<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(3)">
				</div>
				<div style="padding: 40px 20px;display: flex;align-items: center;" class="form">
					 <el-radio-group v-model="setting_data.api_safe">
					    <el-radio :label="1">开启</el-radio>
					    <el-radio :label="0">关闭</el-radio>
					  </el-radio-group>
					<el-button size="small" type="primary" style="margin-left: auto;" round
						@click="toEdit('api_safe',null)">确认修改</el-button>
				</div>
			</div>
		</div>
		<div style="display: flex;flex-direction: column;color:#fff;font-size: 14px;width: 31.5%;margin-bottom: 30px;">
			<div style="flex:1;background-color: rgb(75, 83, 87);display: flex;flex-direction: column;">
				<div style="padding: 15px;border-bottom: 1px solid #3f4649;display: flex;align-items: center;">
					<span>自动售卡手续费支付方</span>
					<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(4)">
				</div>
				<div style="padding: 40px 20px;display: flex;align-items: flex-start;" class="form">
					<el-radio-group v-model="setting_data.is_buyer_pay_platform_fee" style="display: flex;flex-direction: column;color: #fff;">
					   <el-radio :label="1">买家(由卡密买家支付售价金额的3%)</el-radio>
					   <el-radio :label="0" style="margin-top: 15px;">卖家(开发者和代理人均收)</el-radio>
					 </el-radio-group>
					<el-button size="small" type="primary" style="margin-left: auto;" round
						@click="toEdit('api_safe',null)">确认修改</el-button>
				</div>
			</div>
		</div>
		<div style="display: flex;flex-direction: column;color:#fff;font-size: 14px;width: 31.5%;margin-bottom: 30px;">
			<div style="flex:1;background-color: rgb(75, 83, 87);display: flex;flex-direction: column;">
				<div style="padding: 15px;border-bottom: 1px solid #3f4649;display: flex;align-items: center;">
					<span>支付宝结算方式</span>
					<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(5)">
				</div>
				<div style="padding: 40px 20px;display: flex;align-items: center;" class="form">
					<el-radio-group v-model="setting_data.alipay_settle_pattern">
					   <el-radio label="day">日结</el-radio>
					   <el-radio label="times">次结</el-radio>
					 </el-radio-group>
					<el-button size="small" type="primary" style="margin-left: auto;" round
						@click="toEdit('api_safe',null)">确认修改</el-button>
				</div>
			</div>
		</div>
		<el-dialog title="提示" :visible.sync="dialogCodeVisible" width="340px">
			<div style="padding: 0px 10px 0px 10px;font-size: 14px;text-align: center;">
				{{msg}}
			</div>
		</el-dialog>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				setting_data: {
					connect: '',
					inform:'',
					apipassword:'',
					api_safe:1,
				},
				edit_data: {},
				dialogCodeVisible:false,
				msg_list:[
					'如果您想让您的用户能够联系到您，请在这里填写有效联系方式。如果您使用自动售卡等服务，此项必填，否则有封号风险，不填或错填都会引起账号异常。没有使用自动售卡功能可以不填。',
					'公告内容可以通过软件接口读取到，以便实时更新软件公告，没有用到软件公告功能请忽略。',
					'也称apipassword，用于软件和平台的通讯加密及通讯信息验证。',
					'打开此开关后，软件发送至服务器的所有请求，会开启安全验证，服务器会验证发送来的信息是否正确，防止破解。关闭此开关，会对您造成一定的安全隐患。具体请查看接入帮助。',
					'如果选择买家，用户购卡时付款为卡密原价，购卡成功后，开发者和代理人收到的金额为扣除手续费（2.1%）后的金额。如果选择卖家，用户购卡时，付款价格会比原价贵3%，购卡成功后，开发者会收到卡密原价的金额，代理人仍扣除2.1%费用',
					'次结指的是用户购卡时实时到账，日结指的是每日凌晨00:00结算当日全部订单金额。'
				],
				msg:''
			}
		},
		created() {
			this.getSetting()
		},
		methods: {
			openMsg(index){
				this.msg = this.msg_list[index]
				setTimeout(()=>{
					this.dialogCodeVisible = true
				},100)
			},
			toEdit(key, msg) {
				if (msg !== null) {
					if (this.setting_data[key] === '') return this.$message.error(msg)
				}
				this.edit_data[key] = this.setting_data[key]
				this.$H.post('/verify_center/v1_0_1.Center/SettingUpdate',this.setting_data).then(res => {
					if(res.data){
						this.$message.success('处理成功')
						this.getSetting()
					}
				});
			},
			switchChange(e,key){
				console.log(e)
			},
			getSetting() {
				this.$H.post('verify_center/v1_0_1.Center/Setting').then(res => {
					if (res.data) {
						res.data.wechat_day_sell_limit_amount = res.data.wechat_day_sell_limit_amount / 100;
						this.setting_data = res.data;
						this.edit_data = res.data
						console.log(res.data)
					}
				});
			},
		}
	}
</script>

<style scoped>
	.form>>>.el-radio__label{
		color: #fff;
	}
	.form>>>.el-input__inner {
		background-color: rgb(66, 75, 79) !important;
		border: 1px solid #989898 !important;
		color: #fff !important;
		border-radius: 0px !important;
	}
	.t-header {
		padding: 16px;
		border-bottom: 1px solid #909090;
		font-size: 14px;
		font-weight: 700;
		display: flex;
	}

	.t-body {
		padding: 16px;
		border-bottom: 1px solid #909090;
		font-size: 14px;
		font-weight: normal;
		display: flex;
	}

	.t-item {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.centext-box .header {
		font-size: 14px;
		border-bottom: 1px solid #000;

	}

	.form>>>.el-form-item__label {
		color: #fff !important;
	}

	

	.form>>>.el-radio__label {
		color: #fff;
	}

	.form>>>.el-textarea__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}
</style>